export default __webpack_public_path__ + "static/academy-92435addb684b4bb3c000bfe4effd122.png";